import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import PaginationUrlBuilder from '~/admin/helpers/pagination-url-builder';
import axios from 'axios';
import _ from "lodash";

@Module({namespaced: true, stateFactory: true})
export default class ListModule extends VuexModule {
  url;
  loading = false;
  items = [];
  filters = {};
  translatable =  false;
  sort = {
    by: 'id',
    desc: true
  };
  pagination = {
    perPage: 20,
    currentPage: 1,
    total: 0
  };

  /////////////////////////////////////////////////////////
  // GETTERS
  /////////////////////////////////////////////////////////

  get isLoading() {
    return this.loading;
  }

  get getItems() {
    return this.items;
  }

  get getFilters() {
    return this.filters
  }

  get getPagination() {
    return this.pagination;
  }

  get getSort() {
    return this.sort;
  }

  /////////////////////////////////////////////////////////
  // MUTATIONS
  /////////////////////////////////////////////////////////

  @Mutation
  setUrl(url) {
    this.url = url;
  }

  @Mutation
  setLoading(loading) {
    this.loading = loading;
  }

  @Mutation
  setItems(items) {
    this.items = items;
  }

  @Mutation
  setPagination(pagination) {
    this.pagination = pagination;
  }

  @Mutation
  setFilters(filters) {
    this.filters = filters;
  }

  @Mutation
  setSort(sort) {
    this.sort = sort;
  }

  @Mutation
  setTranslatable(translatable) {
    this.translatable = translatable;
  }

  /////////////////////////////////////////////////////////
  // ACTIONS
  /////////////////////////////////////////////////////////

  @Action
  filtering(filters) {
    this.context.commit('setFilters', filters);
    this.context.commit('setPagination', {
      perPage: 20,
      currentPage: 1,
      total: 0
    });

    return this.context.dispatch('fetchAll');
  }

  @Action
  sorting(sort) {
    this.context.commit('setSort', sort);

    return this.context.dispatch('fetchAll');
  }

  @Action
  paginating(page) {
    const pagination = {...this.pagination, currentPage: page};
    this.context.commit('setPagination', pagination);

    return this.context.dispatch('fetchAll');
  }

  @Action
  async fetchAll() {
    const {commit, state, rootGetters} = this.context;
    try {
      if (this.translatable) {
        commit('setFilters', {language: rootGetters.language, ...this.filters});
      }

      commit('setLoading', true);

      const urlBuilder = new PaginationUrlBuilder(state.url, state.pagination, state.sort, state.filters);
      const response = await axios.get(urlBuilder.createUrl());

      commit('setItems', response.data.data);
      commit('setPagination', {
          currentPage: parseInt(response.data.current_page),
          perPage: parseInt(response.data.per_page),
          total: parseInt(response.data.total),
        });

      commit('setLoading', false);
    } catch (e) {
      commit('setLoading', false);
      return e;
    }
  }

  @Action
  fetchAllWithoutPagination() {
    const commit = this.context.commit;

    return new Promise((resolve, reject) => {
      commit('setLoading', true);

      let url = this.url;

      if (this.translatable) {
        const language = this.context.rootGetters.language;
        url = `${this.url}/?language=${language}`;
      }

      axios.get(url)
        .then(response => {
          commit('setItems', response.data);

          commit('setLoading', false);
          resolve();
        })
        .catch(e => {
          commit('setLoading', false);
          reject(e);
        })
    });
  }

  @Action
  deleteItem(item) {
    const commit = this.context.commit;
    const dispatch = this.context.dispatch;
    commit('setItems', this.items.filter(e => e.id !== item.id));

    return new Promise((resolve, reject) => {
      commit('setLoading', true);
      axios.delete(`${this.url}/${item.id}`)
        .then(() => {
          commit('setLoading', false);
          dispatch('fetchAllWithoutPagination')
            .then(() => resolve())
        })
        .catch((error) => {
          commit('setLoading', false);
          dispatch('fetchAllWithoutPagination')
            .then(() => reject(error))
        })
    });
  }

  @Action
  updateItem({item, key = 'id', data = false}) {
    const updated = this.context.state.items.map(element => element[key] === item[key] ? item : element);

    return axios.put(`${this.context.state.url}/${item[key]}`, data ? data : item)
      .then(() => {
        this.context.commit('setItems', updated);
        this.context.commit('setLoading', false);
      });
  }

  @Action
  async fetchAllAppend() {
    const {commit, state, rootGetters} = this.context;
    try {

      commit('setLoading', true);

      const urlBuilder = new PaginationUrlBuilder(this.url, state.pagination, state.sort, state.filters);
      const response = await axios.get(urlBuilder.createUrl());

      _.forEach(response.data.data, (item) => this.items.push(item))

      commit('setItems', this.items);

      commit('setPagination', {
        currentPage: parseInt(response.data.current_page),
        perPage: parseInt(response.data.per_page),
        total: parseInt(response.data.total),
      });

      commit('setLoading', false);
    } catch (e) {
      console.log(e);
      commit('setLoading', false);
      return e;
    }
  }

  @Action
  paginatingAppend(page) {
    const pagination = {...this.pagination, currentPage: page};
    this.context.commit('setPagination', pagination);

    return this.context.dispatch('fetchAllAppend');
  }

}
